import React from "react";

const Overlay = ({ children, show }) => {
  if (!show) return null;

  return <div className="overlay-container">{children}</div>;
};

export default Overlay;
